<template>
    <div class="d-flex flex-column setMaxWidthOfChildren align-items-center">
        <transition name="animation" mode="out-in">
            <div
                v-if="loading"
                class="d-flex justify-content-center flex-column align-items-center"
                key="1"
            >
                <h3>{{ $t('activateuser.step3.header') }}</h3>

                <Spinner
                    class="my-4 text-center"
                    style="color: var(--primary)"
                />

                <LoadingHint
                    class="mb-5 text-center"
                    :hints="$t('activateuser.step3.loadingHints')"
                    :timer="3000"
                    style="overflow: hidden"
                />
            </div>

            <ErrorIndicator
                v-else-if="error"
                :errorMessage="errorMessage"
                :action="handleGoBack"
                :actionLabel="$t('activateuser.step3.goBack')"
            />

            <div v-else key="3">
                <div class="d-flex flex-column align-items-center">
                    <h3 class="text-center">
                        {{ $t('activateuser.step3.successHeader') }}
                    </h3>
                    <h6 class="text-center">
                        {{ $t('activateuser.step3.successSubheader') }}
                    </h6>
                    <div class="my-5" :key="loadingTimeCounter">
                        <img :src="successImage" class="success-image" />
                    </div>
                </div>
                <div class="d-flex mb-4" style="justify-items: stretch">
                    <BaseButton
                        @click="handleComplete"
                        variant="primary"
                        class="mx-3"
                        style="flex-basis: 0; flex-grow: 1"
                    >
                        {{ $t('general.finish') }}
                    </BaseButton>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
// Components
import LoadingHint from '../LoadingHint';
import ErrorIndicator from '../ErrorIndicator';

// Utils
import { recoverErrorMapper } from '~/utils/errors/authErrorMapper';
import IntercomService from '~/services/IntercomService';

// Assets
import successImage from '~/assets/img/success.svg';

export default {
    name: 'Step3',
    components: { LoadingHint, ErrorIndicator },
    props: {
        isLoading: Boolean,
        user: Object,
        error: Error,
        resetData: Function,
    },
    data: () => ({
        successImage: successImage,
        interval: null,
        loadingTimeCounter: 0,
        minLoadingTime: 5, // secs
    }),

    computed: {
        minLoading() {
            return this.loadingTimeCounter < this.minLoadingTime;
        },

        loading() {
            return this.isLoading || this.minLoading;
        },

        errorMessage() {
            return this.error ? recoverErrorMapper(this.error) : '';
        },
    },

    methods: {
        incrementTimer() {
            this.loadingTimeCounter++;
        },
        startNewMinLoadingTimeInterval() {
            this.interval = setInterval(this.incrementTimer, 1000);
        },
        clearMinLoadingTimeInterval() {
            clearInterval(this.interval);
        },
        handleGoBack() {
            if (this.resetData) {
                this.resetData();
            }
            this.$emit('prevpage');
        },
        handleComplete() {
            this.$router.push(this.$URLS.findjobs);
        },
        getFirstName() {
            return this.user ? this.user.firstName : '';
        },
        openContactUs() {
            IntercomService.show();
        },
    },

    mounted() {
        this.startNewMinLoadingTimeInterval();
    },

    watch: {
        loading(value) {
            if (value) {
                this.loadingTimeCounter = 0;
                this.startNewMinLoadingTimeInterval();
            } else {
                this.clearMinLoadingTimeInterval();
            }
        },
    },
};
</script>

<style scoped>
.list-item {
    margin-bottom: 0;
}
.list-item::before {
    content: '- ';
}

.success-image {
    max-width: 240px;
    height: auto;
    object-fit: scale-down;
}
</style>
